import { getPath } from '@/router/common'

const baseUrl = {
  title: '仓储管理（新）',
  path: 'InventoryManagement'
}
export default [
  {
    path: getPath('BasicSettings', baseUrl),
    name: 'BasicSettings',
    component: () => import(/* webpackChunkName: "BasicSettings" */ '@/views/inventoryManagement/basicSettings/index.vue'),
    meta: {
      title: '基础设置'
    }
  },
  {
    path: getPath('ImportSettings', baseUrl),
    name: 'InventoryManagement_ImportSettings',
    component: () => import(/* webpackChunkName: "InventoryManagement_ImportSettings" */ '@/views/inventoryManagement/importSettings/index.vue'),
    meta: {
      title: '商品模板管理'
    }
  },
  {
    path: getPath('ImportTemplate', baseUrl),
    name: 'ImportTemplate',
    component: () => import(/* webpackChunkName: "ImportTemplate" */ '@/views/inventoryManagement/importTemplate/index.vue'),
    meta: {
      title: '页面/网格绑定'
    }
  },
  {
    path: getPath('INStoreImportSettings', baseUrl),
    name: 'INStoreImportSettings',
    component: () => import(/* webpackChunkName: "INStoreImportSettings" */ '@/views/inventoryManagement/iNStoreImportSettings/index.vue'),
    meta: {
      title: '入库模板管理'
    }
  },
  {
    path: getPath('InStore_ImportTemplate', baseUrl),
    name: 'InStore_ImportTemplate',
    component: () => import(/* webpackChunkName: "InStore_ImportTemplate" */ '@/views/inventoryManagement/inStore_ImportTemplate/index.vue'),
    meta: {
      title: '页面/网格绑定'
    }
  },
  {
    path: getPath('OUTStoreImportSettings', baseUrl),
    name: 'OUTStoreImportSettings',
    component: () => import(/* webpackChunkName: "OUTStoreImportSettings" */ '@/views/inventoryManagement/oUTStoreImportSettings/index.vue'),
    meta: {
      title: '出库模板管理'
    }
  },
  {
    path: getPath('OutStore_ImportTemplate', baseUrl),
    name: 'OutStore_ImportTemplate',
    component: () => import(/* webpackChunkName: "OutStore_ImportTemplate" */ '@/views/inventoryManagement/outStore_ImportTemplate/index.vue'),
    meta: {
      title: '页面/网格绑定'
    }
  },
  {
    path: getPath('SupplierManagement', baseUrl),
    name: 'SupplierManagement',
    component: () => import(/* webpackChunkName: "SupplierManagement" */ '@/views/inventoryManagement/supplierManagement/index.vue'),
    meta: {
      title: '货主管理'
    }
  },
  {
    path: getPath('AddOrEditSupplier', baseUrl),
    name: 'AcdOrEditSupplier',
    component: () => import('@/views/inventoryManagement/acdOrEditSupplier/index.vue'),
    meta: {
      title: '新增修改货主'
    }
  },
  {
    path: getPath('CustomerInformation', baseUrl),
    name: 'InventoryManagement_CustomerInformation',
    component: () => import(/* webpackChunkName: "InventoryManagement_CustomerInformation" */ '@/views/inventoryManagement/customerInformation/index.vue'),
    meta: {
      title: '仓储管理-收货人管理'
    }
  },
  {
    path: getPath('AddOrEditCustomer', baseUrl),
    name: 'AddOrEditCustomer',
    component: () => import(/* webpackChunkName: "AddOrEditCustomer" */ '@/views/inventoryManagement/addOrEditCustomer/index.vue'),
    meta: {
      title: '新增修改货主'
    }
  },
  {
    path: getPath('cjManagement', baseUrl),
    name: 'cjManagement',
    component: () => import(/* webpackChunkName: "cjManagement" */ '@/views/inventoryManagement/cjManagement/index.vue'),
    meta: {
      title: '客户管理'
    }
  },
  {
    path: getPath('AddOrEditCJ', baseUrl),
    name: 'AddOrEditCJ',
    component: () => import(/* webpackChunkName: "AddOrEditCJ" */ '@/views/inventoryManagement/addOrEditCJ/index.vue'),
    meta: {
      title: '新增修改厂家'
    }
  },
  {
    path: getPath('PrinterSetWareHouse', baseUrl),
    name: 'PrinterSetWareHouse',
    component: () => import(/* webpackChunkName: "PrinterSetWareHouse" */ '@/views/inventoryManagement/printerSetWareHouse/index.vue'),
    meta: {
      title: '打印设置'
    }
  },
  {
    path: getPath('PrinterRptWareHouse', baseUrl),
    name: 'PrinterRptWareHouse',
    component: () => import(/* webpackChunkName: "PrinterRptWareHouse" */ '@/views/inventoryManagement/printerRptWareHouse/index.vue'),
    meta: {
      title: '打印模板'
    }
  },
  {
    path: getPath('WarehouseArg', baseUrl),
    name: 'WarehouseArg',
    component: () => import(/* webpackChunkName: "WarehouseArg" */ '@/views/inventoryManagement/warehouseArg/index.vue'),
    meta: {
      title: '仓储操作设置'
    }
  },
  {
    path: getPath('WarehouseManagement', baseUrl),
    name: 'WarehouseManagement',
    component: () => import(/* webpackChunkName: "WarehouseManagement" */ '@/views/inventoryManagement/warehouseManagement/index.vue'),
    meta: {
      title: '仓库主档'
    }
  },
  {
    path: getPath('AddOrEditWarehouse', baseUrl),
    name: 'AddOrEditWarehouse',
    component: () => import(/* webpackChunkName: "AddOrEditWarehouse" */ '@/views/inventoryManagement/addOrEditWarehouse/index.vue'),
    meta: {
      title: '新增修改仓库'
    }
  },
  {
    path: getPath('positionIntervalAdd', baseUrl),
    name: 'positionIntervalAdd',
    component: () => import(/* webpackChunkName: "positionIntervalAdd" */ '@/views/inventoryManagement/positionIntervalAdd/index.vue'),
    meta: {
      title: '设置价格标准区间段'
    }
  },
  {
    path: getPath('storageFeeIndex', baseUrl),
    name: 'storageFeeIndex',
    component: () => import(/* webpackChunkName: "storageFeeIndex" */ '@/views/inventoryManagement/storageFeeIndex/index.vue'),
    meta: {
      title: '计费区间段设置主页'
    }
  },
  {
    path: getPath('positionIntervalSetting', baseUrl),
    name: 'positionIntervalSetting',
    component: () => import(/* webpackChunkName: "positionIntervalSetting" */ '@/views/inventoryManagement/positionIntervalSetting/index.vue'),
    meta: {
      title: '区间段设置'
    }
  },
  {
    path: getPath('shipperChecking', baseUrl),
    name: 'shipperChecking',
    component: () => import(/* webpackChunkName: "shipperChecking" */ '@/views/inventoryManagement/shipperChecking/index.vue'),
    meta: {
      title: '货主对账'
    }
  },
  {
    path: getPath('shipperChecking_Detail', baseUrl),
    name: 'shipperChecking_Detail',
    component: () => import(/* webpackChunkName: "shipperChecking_Detail" */ '@/views/inventoryManagement/shipperChecking_Detail/index.vue'),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('ImportSettings', baseUrl),
    name: 'ImportSettings',
    component: () => import(/* webpackChunkName: "ImportSettings" */ '@/views/inventoryManagement/importSettings/index.vue'),
    meta: {
      title: '商品模板管理'
    }
  },
  {
    path: getPath('CreateTYD_part', baseUrl),
    name: 'CreateTYD_part',
    component: () => import(/* webpackChunkName: "CreateTYD_part" */ '@/views/inventoryManagement/createTYD_part/index.vue'),
    meta: {
      title: '拆票生成托运单'
    }
  },
  {
    path: getPath('CommodityManagement', baseUrl),
    name: 'CommodityManagement',
    component: () => import(/* webpackChunkName: "CommodityManagement" */ '@/views/inventoryManagement/commodityManagement/index.vue'),
    meta: {
      title: '仓储管理-商品管理-商品设置'
    }
  },
  {
    path: getPath('ImportCommodity', baseUrl),
    name: 'ImportCommodity',
    component: () => import(/* webpackChunkName: "ImportCommodity" */ '@/views/inventoryManagement/importCommodity/index.vue'),
    meta: {
      title: '物料编码导入记录'
    }
  },
  {
    path: getPath('CommodityMaterialIndex', baseUrl),
    name: 'CommodityMaterialIndex',
    component: () => import(/* webpackChunkName: "CommodityMaterialIndex" */ '@/views/inventoryManagement/commodityMaterialIndex/index.vue'),
    meta: {
      title: '仓储-商品导入'
    }
  },
  {
    path: getPath('CommodityMaterialDetails', baseUrl),
    name: 'CommodityMaterialDetails',
    component: () => import(/* webpackChunkName: "CommodityMaterialDetails" */ '@/views/inventoryManagement/commodityMaterialDetails/index.vue'),
    meta: {
      title: '仓储-商品导入明细'
    }
  },
  {
    path: getPath('AddOrEditCommodity', baseUrl),
    name: 'AddOrEditCommodity',
    component: () => import(/* webpackChunkName: "AddOrEditCommodity" */ '@/views/inventoryManagement/addOrEditCommodity/index.vue'),
    meta: {
      title: '新增修改商品'
    }
  },
  {
    path: getPath('PurchaseOrder', baseUrl),
    name: 'PurchaseOrder',
    component: () => import(/* webpackChunkName: "PurchaseOrder" */ '@/views/inventoryManagement/purchaseOrder/index.vue'),
    meta: {
      title: '采购单管理'
    }
  },
  {
    path: getPath('AddOrEditPurchaseOrder', baseUrl),
    name: 'AddOrEditPurchaseOrder',
    component: () => import(/* webpackChunkName: "AddOrEditPurchaseOrder" */ '@/views/inventoryManagement/addOrEditPurchaseOrder/index.vue'),
    meta: {
      title: '新增修改采购单'
    }
  },
  {
    path: getPath('InboundMgn', baseUrl),
    name: 'InboundMgn',
    component: () => import(/* webpackChunkName: "InboundMgn" */ '@/views/inventoryManagement/inboundMgn/index.vue'),
    meta: {
      title: '入库单管理'
    }
  },
  {
    path: getPath('InboundAudit', baseUrl),
    name: 'InboundAudit',
    component: () => import(/* webpackChunkName: "InboundAudit" */ '@/views/inventoryManagement/inboundAudit/index.vue'),
    meta: {
      title: '入库单审核'
    }
  },
  {
    path: getPath('InStoreImportCommodity', baseUrl),
    name: 'InStoreImportCommodity',
    component: () => import(/* webpackChunkName: "InStoreImportCommodity" */ '@/views/inventoryManagement/inStoreImportCommodity/index.vue'),
    meta: {
      title: '入库导入记录'
    }
  },
  {
    path: getPath('InStoreUPIndex', baseUrl),
    name: 'InStoreUPIndex',
    component: () => import(/* webpackChunkName: "InStoreUPIndex" */ '@/views/inventoryManagement/inStoreUPIndex/index.vue'),
    meta: {
      title: '仓储-入库导入'
    }
  },
  {
    path: getPath('InStoreUPDetails', baseUrl),
    name: 'InStoreUPDetails',
    component: () => import(/* webpackChunkName: "InStoreUPDetails" */ '@/views/inventoryManagement/inStoreUPDetails/index.vue'),
    meta: {
      title: '仓储-入库导入明细'
    }
  },
  {
    path: getPath('AddOrEditInbound', baseUrl),
    name: 'AddOrEditInbound',
    component: () => import(/* webpackChunkName: "AddOrEditInbound" */ '@/views/inventoryManagement/addOrEditInbound/index.vue'),
    meta: {
      title: '新增修改入库单'
    }
  },
  {
    path: getPath('OutboundMgn', baseUrl),
    name: 'OutboundMgn',
    component: () => import(/* webpackChunkName: "OutboundMgn" */ '@/views/inventoryManagement/outboundMgn/index.vue'),
    meta: {
      title: '出库单管理'
    }
  },
  {
    path: getPath('OutboundAudit', baseUrl),
    name: 'OutboundAudit',
    component: () => import(/* webpackChunkName: "OutboundAudit" */ '@/views/inventoryManagement/outboundAudit/index.vue'),
    meta: {
      title: '出库单审核'
    }
  },
  {
    path: getPath('OutStoreImportCommodity', baseUrl),
    name: 'OutStoreImportCommodity',
    component: () => import(/* webpackChunkName: "OutStoreImportCommodity" */ '@/views/inventoryManagement/outStoreImportCommodity/index.vue'),
    meta: {
      title: '出库导入'
    }
  },
  {
    path: getPath('OutStoreUPDetails', baseUrl),
    name: 'OutStoreUPDetails',
    component: () => import(/* webpackChunkName: "OutStoreUPDetails" */ '@/views/inventoryManagement/outStoreUPDetails/index.vue'),
    meta: {
      title: '出库导入明细'
    }
  },
  {
    path: getPath('PlanOutOfStock', baseUrl),
    name: 'PlanOutOfStock',
    component: () => import(/* webpackChunkName: "PlanOutOfStock" */ '@/views/inventoryManagement/planOutOfStock/index.vue'),
    meta: {
      title: '计划出库管理'
    }
  },
  {
    path: getPath('PlannedStorage', baseUrl),
    name: 'PlannedStorage',
    component: () => import(/* webpackChunkName: "PlannedStorage" */ '@/views/inventoryManagement/plannedStorage/index.vue'),
    meta: {
      title: '计划入库管理'
    }
  },
  {
    path: getPath('FinancialStatements', baseUrl),
    name: 'FinancialStatements',
    component: () => import(/* webpackChunkName: "FinancialStatements" */ '@/views/inventoryManagement/financialStatements/index.vue'),
    meta: {
      title: '出入库流水账'
    }
  },
  {
    path: getPath('SalesReturns', baseUrl),
    name: 'SalesReturns',
    component: () => import(/* webpackChunkName: "SalesReturns" */ '@/views/inventoryManagement/salesReturns/index.vue'),
    meta: {
      title: '销售退货'
    }
  },
  {
    path: getPath('PurchaseReturn', baseUrl),
    name: 'PurchaseReturn',
    component: () => import(/* webpackChunkName: "PurchaseReturn" */ '@/views/inventoryManagement/purchaseReturn/index.vue'),
    meta: {
      title: '采购退货'
    }
  },
  {
    path: getPath('arbitrationInquire', baseUrl),
    name: 'arbitrationInquire',
    component: () => import(/* webpackChunkName: "arbitrationInquire" */ '@/views/inventoryManagement/arbitrationInquire/index.vue'),
    meta: {
      title: '仲裁查询处理'
    }
  },
  {
    path: getPath('jettisonManage', baseUrl),
    name: 'jettisonManage',
    component: () => import(/* webpackChunkName: "jettisonManage" */ '@/views/inventoryManagement/jettisonManage/index.vue'),
    meta: {
      title: '弃货管理'
    }
  },
  {
    path: getPath('headlessSingle', baseUrl),
    name: 'headlessSingle',
    component: () => import(/* webpackChunkName: "headlessSingle" */ '@/views/inventoryManagement/headlessSingle/index.vue'),
    meta: {
      title: '无头件管理'
    }
  },
  {
    path: getPath('problemShipment', baseUrl),
    name: 'inventoryManagement_problemShipment',
    component: () => import(/* webpackChunkName: "inventoryManagement_problemShipment" */ '@/views/inventoryManagement/problemShipment/index.vue'),
    meta: {
      title: '问题件管理'
    }
  },
  {
    path: getPath('customEntryfee', baseUrl),
    name: 'customEntryfee',
    component: () => import(/* webpackChunkName: "customEntryfee" */ '@/views/inventoryManagement/customEntryfee/index.vue'),
    meta: {
      title: '费用管理'
    }
  },
  {
    path: getPath('customCost', baseUrl),
    name: 'customCost',
    component: () => import(/* webpackChunkName: "customCost" */ '@/views/inventoryManagement/customCost/index.vue'),
    meta: {
      title: '自定义项目'
    }
  },
  {
    path: getPath('shipperCheckingList', baseUrl),
    name: 'shipperCheckingList',
    component: () => import(/* webpackChunkName: "shipperCheckingList" */ '@/views/inventoryManagement/shipperCheckingList/index.vue'),
    meta: {
      title: '货主对账单'
    }
  },
  {
    path: getPath('receiptFactoryReport', baseUrl),
    name: 'receiptFactoryReport',
    component: () => import(/* webpackChunkName: "receiptFactoryReport" */ '@/views/inventoryManagement/receiptFactoryReport/index.vue'),
    meta: {
      title: '回单返厂报表'
    }
  },
  {
    path: getPath('receiptFactory', baseUrl),
    name: 'receiptFactory',
    component: () => import(/* webpackChunkName: "receiptFactory" */ '@/views/inventoryManagement/receiptFactory/index.vue'),
    meta: {
      title: '回单返厂'
    }
  },
  {
    path: getPath('receiptSignReport', baseUrl),
    name: 'receiptSignReport',
    component: () => import(/* webpackChunkName: "receiptSignReport" */ '@/views/inventoryManagement/receiptSignReport/index.vue'),
    meta: {
      title: '回单签收报表'
    }
  },
  {
    path: getPath('receiptSign', baseUrl),
    name: 'receiptSign',
    component: () => import(/* webpackChunkName: "receiptSign" */ '@/views/inventoryManagement/receiptSign/index.vue'),
    meta: {
      title: '回单签收'
    }
  },
  {
    path: getPath('deliverGoods', baseUrl),
    name: 'deliverGoods',
    component: () => import(/* webpackChunkName: "deliverGoods" */ '@/views/inventoryManagement/deliverGoods/index.vue'),
    meta: {
      title: '配送单'
    }
  },
  {
    path: getPath('sortingOrder', baseUrl),
    name: 'sortingOrder',
    component: () => import(/* webpackChunkName: "sortingOrder" */ '@/views/inventoryManagement/sortingOrder/index.vue'),
    meta: {
      title: '分拣单'
    }
  },
  {
    path: getPath('InventoryLoss', baseUrl),
    name: 'InventoryLoss',
    component: () => import(/* webpackChunkName: "InventoryLoss" */ '@/views/inventoryManagement/inventoryLoss/index.vue'),
    meta: {
      title: '盘亏单管理'
    }
  },
  {
    path: getPath('InventoryProfit', baseUrl),
    name: 'InventoryProfit',
    component: () => import(/* webpackChunkName: "InventoryProfit" */ '@/views/inventoryManagement/inventoryProfit/index.vue'),
    meta: {
      title: '盘盈单管理'
    }
  },
  {
    path: getPath('InventoryChecking', baseUrl),
    name: 'InventoryChecking',
    component: () => import(/* webpackChunkName: "InventoryChecking" */ '@/views/inventoryManagement/inventoryChecking/index.vue'),
    meta: {
      title: '盘点单管理'
    }
  },
  {
    path: getPath('InternalBusiness', baseUrl),
    name: 'InternalBusiness',
    component: () => import(/* webpackChunkName: "InternalBusiness" */ '@/views/inventoryManagement/internalBusiness/index.vue'),
    meta: {
      title: '调拨单管理'
    }
  },
  {
    path: getPath('AddOrEditInternalBusiness', baseUrl),
    name: 'AddOrEditInternalBusiness',
    component: () => import(/* webpackChunkName: "AddOrEditInternalBusiness" */ '@/views/inventoryManagement/addOrEditInternalBusiness/index.vue'),
    meta: {
      title: '新增修改查看调拨单'
    }
  },
  {
    path: getPath('AddOrEditInventoryChecking', baseUrl),
    name: 'AddOrEditInventoryChecking',
    component: () => import(/* webpackChunkName: "AddOrEditInventoryChecking" */ '@/views/inventoryManagement/addOrEditInventoryChecking/index.vue'),
    meta: {
      title: '新增修改查看盘点单'
    }
  },
  {
    path: getPath('AddOrEditInventoryProfit', baseUrl),
    name: 'AddOrEditInventoryProfit',
    component: () => import(/* webpackChunkName: "AddOrEditInventoryProfit" */ '@/views/inventoryManagement/addOrEditInventoryProfit/index.vue'),
    meta: {
      title: '新增修改查看盘盈单'
    }
  },
  {
    path: getPath('AddOrEditInventoryLoss', baseUrl),
    name: 'AddOrEditInventoryLoss',
    component: () => import(/* webpackChunkName: "AddOrEditInventoryLoss" */ '@/views/inventoryManagement/addOrEditInventoryLoss/index.vue'),
    meta: {
      title: '新增修改查看盘亏单'
    }
  },
  {
    path: getPath('AddOrEditDelivery', baseUrl),
    name: 'AddOrEditDelivery',
    component: () => import(/* webpackChunkName: "AddOrEditDelivery" */ '@/views/inventoryManagement/addOrEditDelivery/index.vue'),
    meta: {
      title: '新增修改查看分拣单'
    }
  },
  {
    path: getPath('AddDeliverGoods', baseUrl),
    name: 'AddDeliverGoods',
    component: () => import(/* webpackChunkName: "AddDeliverGoods" */ '@/views/inventoryManagement/addDeliverGoods/index.vue'),
    meta: {
      title: '新增修改查看配送单'
    }
  },
  {
    path: getPath('shipperCheckingList_Detail', baseUrl),
    name: 'shipperCheckingList_Detail',
    component: () => import(/* webpackChunkName: "shipperCheckingList_Detail" */ '@/views/inventoryManagement/shipperCheckingList_Detail/index.vue'),
    meta: {
      title: '货主对账单明细'
    }
  },
  {
    path: getPath('customCostAdd', baseUrl),
    name: 'customCostAdd',
    component: () => import(/* webpackChunkName: "customCostAdd" */ '@/views/inventoryManagement/customCostAdd/index.vue'),
    meta: {
      title: '新增修改项目'
    }
  },
  {
    path: getPath('customEntryfeeAdd', baseUrl),
    name: 'customEntryfeeAdd',
    component: () => import(/* webpackChunkName: "customEntryfeeAdd" */ '@/views/inventoryManagement/customEntryfeeAdd/index.vue'),
    meta: {
      title: '编辑项目费用'
    }
  },
  {
    path: getPath('problemAddOrModify', baseUrl),
    name: 'inventoryManagement_problemAddOrModify',
    component: () => import(/* webpackChunkName: "inventoryManagement_problemAddOrModify" */ '@/views/inventoryManagement/problemAddOrModify/index.vue'),
    meta: {
      title: '问题件上报修改回复详情提交仲裁'
    }
  },
  {
    path: getPath('noHeaderfileAddOrModify', baseUrl),
    name: 'inventoryManagement_noHeaderfileAddOrModify',
    component: () => import(/* webpackChunkName: "inventoryManagement_noHeaderfileAddOrModify" */ '@/views/inventoryManagement/noHeaderfileAddOrModify/index.vue'),
    meta: {
      title: '无头件上报修改认领审核详情提交仲裁'
    }
  },
  {
    path: getPath('asterAddOrModify', baseUrl),
    name: 'inventoryManagement_asterAddOrModify',
    component: () => import(/* webpackChunkName: "inventoryManagement_asterAddOrModify" */ '@/views/inventoryManagement/asterAddOrModify/index.vue'),
    meta: {
      title: '弃件上报'
    }
  },
  {
    path: getPath('arbitrationHandle', baseUrl),
    name: 'inventoryManagement_arbitrationHandle',
    component: () => import(/* webpackChunkName: "inventoryManagement_arbitrationHandle" */ '@/views/inventoryManagement/arbitrationHandle/index.vue'),
    meta: {
      title: '问题件无头件弃件仲裁'
    }
  },
  {
    path: getPath('AddOrEditPurchaseReturn', baseUrl),
    name: 'AddOrEditPurchaseReturn',
    component: () => import(/* webpackChunkName: "AddOrEditPurchaseReturn" */ '@/views/inventoryManagement/addOrEditPurchaseReturn/index.vue'),
    meta: {
      title: '新增修改查看采购退货单'
    }
  },
  {
    path: getPath('AddOrEditSalesReturns', baseUrl),
    name: 'AddOrEditSalesReturns',
    component: () => import(/* webpackChunkName: "AddOrEditSalesReturns" */ '@/views/inventoryManagement/addOrEditSalesReturns/index.vue'),
    meta: {
      title: '新增修改查看销售退货单'
    }
  },
  {
    path: getPath('FinancialStatementsDetails', baseUrl),
    name: 'FinancialStatementsDetails',
    component: () => import(/* webpackChunkName: "FinancialStatementsDetails" */ '@/views/inventoryManagement/financialStatementsDetails/index.vue'),
    meta: {
      title: '出入库流水账明细'
    }
  },
  {
    path: getPath('AddOrEditPlannedStorage', baseUrl),
    name: 'AddOrEditPlannedStorage',
    component: () => import(/* webpackChunkName: "AddOrEditPlannedStorage" */ '@/views/inventoryManagement/addOrEditPlannedStorage/index.vue'),
    meta: {
      title: '新增修改查看计划入库单'
    }
  },
  {
    path: getPath('AddOrEditPlanOutOfStock', baseUrl),
    name: 'AddOrEditPlanOutOfStock',
    component: () => import(/* webpackChunkName: "AddOrEditPlanOutOfStock" */ '@/views/inventoryManagement/addOrEditPlanOutOfStock/index.vue'),
    meta: {
      title: '新增修改查看计划出库单'
    }
  },
  {
    path: getPath('OutStoreUPIndex', baseUrl),
    name: 'OutStoreUPIndex',
    component: () => import(/* webpackChunkName: "OutStoreUPIndex" */ '@/views/inventoryManagement/outStoreUPIndex/index.vue'),
    meta: {
      title: '仓储-出库导入'
    }
  },
  {
    path: getPath('AddOrEditSupplier', baseUrl),
    name: 'inventoryManagement_addOrEditSupplier',
    component: () => import(/* webpackChunkName: "inventoryManagement_addOrEditSupplier" */ '@/views/inventoryManagement/addOrEditSupplier/index.vue'),
    meta: {
      title: '新增修改货主'
    }
  },
  {
    path: getPath('RptModelManaEdit', baseUrl),
    name: 'inventoryManagement_rptModelManaEdit',
    component: () => import(/* webpackChunkName: "inventoryManagement_rptModelManaEdit" */ '@/views/inventoryManagement/rptModelManaEdit/index.vue'),
    meta: {
      title: '新增修改模板'
    }
  },
  {
    path: getPath('storageAdd', baseUrl),
    name: 'inventoryManagement_storageAdd',
    component: () => import(/* webpackChunkName: "inventoryManagement_storageAdd" */ '@/views/inventoryManagement/storageAdd/index.vue'),
    meta: {
      title: '导入运单'
    }
  },
  {
    path: getPath('AddOrEditOutbound', baseUrl),
    name: 'InventoryManagement_AddOrEditOutbound',
    component: () => import(/* webpackChunkName: "InventoryManagement_AddOrEditOutbound" */ '@/views/inventoryManagement/addOrEditOutbound/index.vue'),
    meta: {
      title: '新增修改查看出库单'
    }
  },
  {
    path: getPath('CangchuPriceStandard', baseUrl),
    name: 'InventoryManagement_PriceStandard',
    component: () => import(/* webpackChunkName: "InventoryManagement_PriceStandard" */ '@/views/inventoryManagement/cangchuPriceStandard/index.vue'),
    meta: {
      title: '仓储价格标准'
    }
  },
  {
    path: getPath('CangchuPriceStandard/add', baseUrl),
    name: 'InventoryManagement_PriceStandardAdd',
    component: () => import(/* webpackChunkName: "InventoryManagement_PriceStandardAdd" */ '@/views/inventoryManagement/cangchuPriceStandard/add.vue'),
    meta: {
      title: '批量新增仓储价格标准'
    }
  }
]
